import { render, staticRenderFns } from "./PageAddressInvalid.vue?vue&type=template&id=07ed7773&"
import script from "./PageAddressInvalid.vue?vue&type=script&lang=js&"
export * from "./PageAddressInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports